<!-- =========================
     FULLSCREEN BACKGROUND
========================= -->
<div class="min-vh-100 position-relative overflow-hidden">

  <!-- Extra-dim Overlay (same as login/reset) -->
  <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>

  <!-- =========================
       CONTENT LAYER (Split Screen)
  =========================== -->
  <div class="container-fluid position-relative z-1 min-vh-100">
    <div class="row d-flex min-vh-100">

      <!-- Left illustration/marketing column (show from md and up, same as login/reset) -->
      <div class="col-6 col-md-6 d-none d-md-flex bg-warning text-white login-panel-left">
        <div class="d-flex flex-column justify-content-center align-items-center vh-100 w-100 px-5">
          <div class="absolute-top-left">
            <router-link
              to="/"
              class="auth-logo mb-2 text-decoration-none d-inline-block"
              aria-label="NPI Home"
            ></router-link>
          </div>

          <h3 class="fw-bold mb-4 text-dark">
            Manage Your B-BBEE Compliance with Confidence
          </h3>
          <p class="text-dark text-sm">
            Track programmes, prepare audit packs, and achieve your target BEE level with our comprehensive platform.
          </p>
        </div>
      </div>

      <!-- Right column: create new password form (same structure as login/reset) -->
      <div class="col-12 col-md-6 d-flex align-items-center justify-content-center vh-100 flex-column">
        <div class="p-4 p-md-5 login-panel">

          <!-- Heading -->
          <h3 class="fw-bold mb-1 text-white">
           One Time Pin
          </h3>

          <p class="text-white-50 mb-4 text-sm">
             We've sent a 6-digit security code to
          </p>

          <!-- Error -->
          <div
            v-if="error_message"
            class="alert alert-danger alert-dismissible fade show rounded-3"
            role="alert"
          >
            {{ error_message }}
            <button
              type="button"
              class="btn-close"
              @click="error_message = ''"
            ></button>
          </div>

          <!-- Success -->
          <div
            v-if="success_message"
            class="alert alert-success alert-dismissible fade show rounded-3"
            role="alert"
          >
            {{ success_message }}
            <button
              type="button"
              class="btn-close"
              @click="success_message = ''"
            ></button>
          </div>

          <!-- =========================
             OTP FORM
        =========================== -->
        <form @submit.prevent="submit_otp">

          <!-- OTP INPUTS -->
          <div class="d-flex justify-content-between mb-4 otp-inputs">

            <input
              v-for="(digit,index) in otp"
              :key="index"
              maxlength="1"
              v-model="otp[index]"
              @input="handle_input(index,$event)"
              @paste="handle_paste(index,$event)"
              @keydown.backspace="handle_backspace(index,$event)"
              inputmode="numeric"
              autocomplete="one-time-code"
              class="form-control text-center bg-transparent text-white border-secondary rounded-3 otp-input-box"
            />

          </div>



          <!-- Resend -->
          <p class="text-start text-white-50 text-xs mb-2">

            Didn't receive the code?

            <span
              class="text-primary cursor-pointer fw-bold"
              @click="resend_otp"
            >
              Resend OTP
            </span>

          </p>

          <!-- Timer -->
          <p class="text-start text-white-50 text-xs mb-0">

            You can resend in

            <strong>
              {{ formatted_timer }}
            </strong>

          </p>

          <!-- Back -->
          <p class="text-start mt-3 mb-0 text-xs">

            <router-link
              to="/login"
              class="text-decoration-none text-white-50"
            >
              ← Back to login
            </router-link>

          </p>

        </form>


        </div>
      </div>

    </div>
  </div>
</div>
